// MIME type constants for document filtering
export const DOCUMENT_MIME_TYPES = {
  // Microsoft Word documents
  WORD_DOCX:
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  WORD_APPLICATION_DOCX: 'application/docx',
} as const;

export const DEFAULT_DOCUMENT_CONTENT_TYPES = [
  DOCUMENT_MIME_TYPES.WORD_DOCX,
  DOCUMENT_MIME_TYPES.WORD_APPLICATION_DOCX,
];
